/* 申請寄養家長 */
import React from 'react';
import { isMobile } from '@/utils';

function FosterCareService(props) {
  if (isMobile()) {
    const Mobile = require('./FosterCareService').default;
    return <Mobile {...props} />;
  }
  const Web = require('./WebFosterCareService').default;
  return <Web {...props} />;
}

export default FosterCareService;
